import Api from "./axios";

export const getAdminBankDetailList = async () => {
  return await Api.get("/admin/get-admin-all-qr-code-details");
};
